<template>
  <a-spin :spinning="spinning">
    <a-row :gutter="20" v-if="privacyList.length">
      <a-col v-for="(item,index) in privacyList" :key='index' :span="12">
        <a-card class="m-b-20 height-140" hoverable>
          <p class="fz-16 p-b-8 ">{{item.api_ch_name}}</p>
          <div class="s_flex_bian">
            <div class="s_c999 width80">
              {{item.api_desc}}
              <a href="javascript:;" @click="lookMore(item.api_link)">查看详情</a>
              <a-tooltip v-if="item.status == 4">
                <template #title>
                  <p>{{item.fail_reason}}</p>
                </template>
                <a class="m-l-20" href="javascript:;">失败原因</a>
              </a-tooltip>
            </div>
            <a-button v-has:appletApplyPrivacy="()=>open(item)" v-if="item.status == 1">去开通</a-button>
            <p class="s_c999" v-if="item.status == 2">无权限<a-tooltip >
                <template #title>
                  <p>{{item.fail_reason}}</p>
                </template>
                <a class="m-l-20" href="javascript:;">原因</a>
              </a-tooltip></p>
            <p class="s_c999" v-if="item.status == 3">申请中
              </p>
            <p class="s_c999" v-has:appletApplyPrivacy="()=>open(item)" v-if="item.status == 4">申请失败
              <RightOutlined />
            </p>
            <p class="s_c999" v-if="item.status == 5">已开通</p>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <div class="s_flex_center" style="height:400px" v-else>
      <a-empty />
    </div>
  </a-spin>
  <a-modal v-model:visible="visible" centered destroyOnClose :width="1000" :footer="null">
    <p class="fz-30">{{form.api_name+'接口申请'}}</p>
    <p class="s_c999 m-b-24">你正在提交接口申请，所有信息请如实填写，所填信息只用于审核。</p>
    <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 15 }" ref="ruleForm" :model="form" :rules="rules">
      <a-form-item ref="content" label="申请原因" name="content">
        <a-textarea v-model:value="form.content" showCount :maxlength="300" placeholder="详细描述接口能力的具体使用场景。" :rows="4" />
      </a-form-item>
      <a-form-item ref="pic_list" label="辅助图片" name="pic_list">

        <div class=" flex flex-wrap">
          <div class="relative mx-5" v-for="(v, index) in form.pic_list" :key="index">
            <a-image
              :src="v"
              :width="100"
            >
            </a-image>
            <div class="absolute top-0 right-0 px-5 py-5 text-warning leading-100f" @click.stop="imgOnDelete(index)"><DeleteOutlined /></div>
          </div>
          <div class="w-100 h-100 relative ml-10">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess($event)"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
              <div @click.stop="imgOnReset" class="absolute right-0 top-0 px-5 py-5 z-100 leading-100f" title="重置为默认的图片列表，在里面进行筛选所需上传的图片"><SyncOutlined /></div>
            </div>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
        <a-button type="primary" @click="onSubmit" :loading='loading'>
          提交申请
        </a-button>
        <a-button class="m-l-20" @click="visible = false">
          取消
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import { RightOutlined, DeleteOutlined, PlusOutlined, SyncOutlined } from "@ant-design/icons-vue";
  import { getPrivacyList, setApplyPrivacy } from "@/api/appletCode";
  import { message } from 'ant-design-vue';
  import { useRoute } from 'vue-router';
  import { $iscode } from '@/utils/app';
  import * as util from '@/utils/utils';
  import { onMounted, ref, inject, reactive, toRefs } from '@vue/runtime-core';
  import store from "@/store";
  import uploadImage from "@/components/image/uploadImage.vue";
  // 初始化默认筛选项数值
  let defForm = {
    brand_id: '',
    appid: '',
    api_name: '',
    content: '',
    url_list: '',
    pic_list: [],
    video_list: ''
  }
  export default {
    components: { uploadImage, RightOutlined, DeleteOutlined, PlusOutlined, SyncOutlined },
    setup() {
      const $Modal = inject("$Modal");
      const form = ref({ ...defForm });
      const state = reactive({
        info: store.state.user.info,
        privacyItem: {},
        visible: false,
        loading: false,
        rules: {
          content: [
            { required: true, message: '请输入申请原因' }
          ]
        }
      });
      const $route = inject('$route');
      const $router = inject("$router");
      const privacyList = ref([]);
      const spinning = ref(true);
      //查看详情
      const lookMore = (url) => {
        window.open(url)
      }
      //去开通
      const open = (data) => {
        form.value.api_name = data.api_name;
        if (form.value.api_name == 'wx.getLocation') {
          form.value.content = '因当前业务涉及匹配附近门店和商品门店自提服务，需获取用户地理位置信息匹配附近门店';
          form.value.pic_list = [urlToAbsolute('/web_base_assets/getLocation1.png'),urlToAbsolute('/web_base_assets/getLocation2.png')];
        }
        state.visible = true
      }
      let defaultImgs = [
      '/web_base_assets/getLocation3.png',
      '/web_base_assets/getLocation4.png',
      '/web_base_assets/getLocation1.png',
      '/web_base_assets/getLocation2.png',
      ]
      const urlToAbsolute = (url) => {
        return util.urlToAbsolute(url, state.info.picdomain)
      }
      
      // 图片上传
      const uploadOnSuccess = (data) => {
        form.value.pic_list.push(urlToAbsolute(data.path));
      };
      const imgOnDelete = (index) => {
        form.value.pic_list.splice(index, 1);
      }
      // 重置图片，从这里图片进行筛选来提交(因为不同权限要的图片不同)
      const imgOnReset = () => {
        $Modal.confirm({
          content: '确定重置为默认图片列表？重置后当前上传的图片会被清空！',
          centered:true,
           onOk:async () => {
             let data = JSON.parse(JSON.stringify(defaultImgs));
             data = data.map(item => urlToAbsolute(item))
             form.value.pic_list = data
          }
        })
      }
      const ruleForm = ref()
      //开通
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          state.loading = true
          let res = await setApplyPrivacy({ ...form.value, brand_id: $route.query.brand_id, appid: $route.query.app_id,miniapp_type:$route.query.miniapp_type?$route.query.miniapp_type:"" }).then(res => res.data).catch(error => error);
          if ($iscode(res)) {
            message.success(res.msg);
            state.visible = false;
            initData();
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
          state.loading = false
        }).catch(error => {
          console.log('error', error);
        });
      }
      //获取列表
      const initData = async () => {
        spinning.value = true;
        let result = await getPrivacyList({ brand_id: $route.query.brand_id, appid: $route.query.app_id,miniapp_type:$route.query.miniapp_type?$route.query.miniapp_type:"" }).then(res => res.data).catch(error => error);
        console.log(result)
        if ($iscode(result)) {
          privacyList.value = result.data.interface_list
        }
        spinning.value = false;
      }
      onMounted(() => {
        initData()
      })
      return {
        ...toRefs(state),
        privacyList,
        spinning,
        form,
        open,
        onSubmit,
        ruleForm,
        lookMore,
        uploadOnSuccess,
        imgOnDelete,
        imgOnReset
      }

    }
  };
</script>